export default "__VITE_ASSET__1qgZsQQJ__"